import { RootState } from "../../store";
import { AccountAttemptStatusDetailsAwsStarted } from "../../../services/cloudchipr.api";

export const awsTerraform = (state: RootState): string | undefined =>
  (
    state.accountSetup.accountAttempt?.status_details
      ?.started as AccountAttemptStatusDetailsAwsStarted
  )?.terraform;
